import React from 'react';
import imageSrc from "../images/services/home-about.webp";
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaRocket, FaChartLine, FaUsers, FaLightbulb, FaArrowRight } from 'react-icons/fa';

const AboutSection = () => {
  const features = [
    {
      icon: <FaRocket />,
      title: "Strategic Growth",
      description: "Data-driven strategies that accelerate your business growth"
    },
    {
      icon: <FaChartLine />,
      title: "Proven Results",
      description: "Track record of delivering measurable success for our clients"
    },
    {
      icon: <FaUsers />,
      title: "Expert Team",
      description: "Experienced professionals dedicated to your success"
    },
    {
      icon: <FaLightbulb />,
      title: "Innovation",
      description: "Cutting-edge solutions tailored to your unique needs"
    }
  ];

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.1
      }
    }
  };

  const item = {
    hidden: {
      y: 50,
      opacity: 0,
      scale: 0.9
    },
    show: {
      y: 0,
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.6,
        ease: [0.25, 0.46, 0.45, 0.94]
      }
    }
  };

  const cardHover = {
    y: -4,
    scale: 1.01,
    transition: {
      duration: 0.3,
      ease: "easeOut"
    }
  };

  const iconHover = {
    scale: 1.05,
    rotate: 3,
    transition: {
      duration: 0.3,
      ease: "easeOut"
    }
  };

  return (
    <section className="py-5 position-relative overflow-hidden" style={{
      background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)'
    }}>
      {/* Background Elements */}
      <div className="position-absolute top-0 start-0 w-100 h-100" style={{
        background: 'radial-gradient(circle at 20% 80%, rgba(59, 130, 246, 0.05) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(16, 185, 129, 0.05) 0%, transparent 50%)'
      }}></div>

      <div className="container position-relative">
        <div className="row align-items-center">
          <motion.div
            className="col-lg-6 mb-5 mb-lg-0"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            <div className="position-relative">
              <motion.div
                className="about-image position-relative"
                whileHover={{ scale: 1.02 }}
                transition={{ duration: 0.3 }}
              >
                <img
                  src={imageSrc}
                  alt="GrowthVibe Team"
                  className="img-fluid rounded-4 shadow-lg"
                  style={{
                    width: '100%',
                    height: 'clamp(300px, 50vw, 500px)',
                    objectFit: 'cover'
                  }}
                />
                {/* Decorative Elements */}
                <div className="position-absolute top-0 start-0 w-100 h-100 rounded-4" style={{
                  background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(16, 185, 129, 0.1) 100%)',
                  opacity: 0.3
                }}></div>
              </motion.div>

              {/* Floating Cards - Hidden on mobile, visible on larger screens */}
              {/* <motion.div
                className="position-absolute top-0 end-0 translate-middle-y d-none d-md-block"
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8, delay: 0.3 }}
                viewport={{ once: true }}
                style={{ transform: 'translateY(-50%)' }}
              >
                <div className="card border-0 shadow-lg" style={{
                  background: 'rgba(255, 255, 255, 0.95)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '20px',
                  padding: 'clamp(1rem, 2vw, 1.5rem)',
                  minWidth: 'clamp(150px, 15vw, 200px)'
                }}>
                  <div className="d-flex align-items-center">
                    <div className="me-3">
                      <div className="d-inline-flex align-items-center justify-content-center rounded-4 text-white" style={{
                        width: 'clamp(40px, 4vw, 50px)',
                        height: 'clamp(40px, 4vw, 50px)',
                        background: 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
                        boxShadow: '0 8px 25px rgba(59, 130, 246, 0.3)'
                      }}>
                        <FaChartLine style={{ fontSize: 'clamp(0.8rem, 1.5vw, 1rem)' }} />
                      </div>
                    </div>
                    <div>
                      <h6 className="mb-1 fw-bold text-dark" style={{ fontSize: 'clamp(0.8rem, 1.2vw, 1rem)' }}>500+ Projects</h6>
                      <p className="mb-0 text-muted small" style={{ fontSize: 'clamp(0.7rem, 1vw, 0.8rem)' }}>Successfully Completed</p>
                    </div>
                  </div>
                </div>
              </motion.div> */}
            </div>
          </motion.div>

          <motion.div
            className="col-lg-6"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
              className="text-center text-lg-start"
            >
              <motion.span
                className="badge bg-primary-subtle text-primary mb-3 px-3 py-2 rounded-pill"
                style={{ fontSize: 'clamp(0.8rem, 1.5vw, 0.9rem)', fontWeight: '500' }}
                initial={{ scale: 0.8, opacity: 0 }}
                whileInView={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.3 }}
                viewport={{ once: true }}
              >
                About Us
              </motion.span>
              <h2 className="fw-bold mb-4 gradient-text-animated" style={{ fontSize: 'clamp(2rem, 4vw, 3rem)' }}>
                About GrowthVibe
              </h2>
              <p className="lead text-muted mb-4" style={{
                fontSize: 'clamp(1rem, 2vw, 1.1rem)',
              }}>
                At GrowthVibe, we're more than just a marketing agency — we're your growth partner. We combine strategic thinking with cutting-edge technology to deliver results that matter.
              </p>
            </motion.div>

            <motion.div
              className="row g-2 g-md-3 mb-4"
              variants={container}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.2 }}
            >
              {features.map((feature, index) => (
                <motion.div
                  key={index}
                  className="col-12 col-sm-6"
                  variants={item}
                  whileHover={cardHover}
                >
                  <div className="d-flex align-items-center p-2 p-md-3 rounded-3" style={{
                    background: 'rgba(255, 255, 255, 0.7)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    transition: 'all 0.3s ease',
                    minHeight: 'clamp(60px, 8vw, 80px)'
                  }}>
                    <motion.div
                      className="me-2 me-md-3"
                      whileHover={iconHover}
                    >
                      <div className="d-inline-flex align-items-center justify-content-center rounded-3 text-white" style={{
                        width: 'clamp(35px, 5vw, 40px)',
                        height: 'clamp(35px, 5vw, 40px)',
                        background: 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
                        boxShadow: '0 4px 15px rgba(59, 130, 246, 0.3)'
                      }}>
                        <span style={{ fontSize: 'clamp(0.8rem, 1.5vw, 1rem)' }}>{feature.icon}</span>
                      </div>
                    </motion.div>
                    <div className="flex-grow-1">
                      <h6 className="mb-1 fw-bold text-dark" style={{ fontSize: 'clamp(0.8rem, 1.5vw, 0.9rem)' }}>
                        {feature.title}
                      </h6>
                      <p className="mb-0 text-muted small d-none d-sm-block" style={{ fontSize: 'clamp(0.7rem, 1.2vw, 0.8rem)' }}>
                        {feature.description}
                      </p>
                    </div>
                  </div>
                </motion.div>
              ))}
            </motion.div>

            <motion.div
              className="d-flex flex-column flex-sm-row flex-wrap gap-2 gap-md-3 justify-content-center justify-content-lg-start"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <motion.div whileHover={{ y: -2 }} whileTap={{ scale: 0.98 }} className="flex-grow-1 flex-sm-grow-0">
                <Link
                  to="/services"
                  className="btn btn-primary btn-lg px-4 px-md-5 py-2 py-md-3 rounded-pill d-inline-flex align-items-center justify-content-center gap-2 w-100"
                  style={{
                    background: 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
                    border: 'none',
                    fontWeight: '600',
                    fontSize: 'clamp(0.9rem, 1.8vw, 1rem)',
                    boxShadow: '0 8px 25px rgba(59, 130, 246, 0.3)',
                    transition: 'all 0.3s ease',
                    minWidth: "clamp(150px, 20vw, 180px)"
                  }}
                >
                  Our Services
                  <FaArrowRight style={{ fontSize: 'clamp(0.8rem, 1.5vw, 1rem)' }} />
                </Link>
              </motion.div>
              <motion.div whileHover={{ y: -2 }} whileTap={{ scale: 0.98 }} className="flex-grow-1 flex-sm-grow-0">
                <Link
                  to="/contact"
                  className="btn btn-outline-primary btn-lg px-4 px-md-5 py-2 py-md-3 rounded-pill d-inline-flex align-items-center justify-content-center gap-2 w-100"
                  style={{
                    borderWidth: '2px',
                    fontWeight: '600',
                    fontSize: 'clamp(0.9rem, 1.8vw, 1rem)',
                    transition: 'all 0.3s ease',
                    minWidth: "clamp(150px, 20vw, 180px)"
                  }}
                >
                  Get Started
                  <FaArrowRight style={{ fontSize: 'clamp(0.8rem, 1.5vw, 1rem)' }} />
                </Link>
              </motion.div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
